import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  exhaustMap,
  map,
} from 'rxjs/operators';
import { of } from 'rxjs';

import {
  actionBrandLineConfigGet,
  actionBrandLineConfigGetFailure,
  actionBrandLineConfigGetSuccess,
} from './configs.actions';
import { ConfiguratorService, GetConfigParams, GetConfigResponse } from '../..';

@Injectable({
  providedIn: 'root',
})
export class ConfigsEffects {
  constructor(
    private configuratorService: ConfiguratorService,
    private actions$: Actions,
  ) {}

  /**
   * Get the list of brands
   */
  getBrandLineConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actionBrandLineConfigGet),
      exhaustMap((action: { payload: Partial<GetConfigParams> }) => {
        return this.configuratorService
          .getConfig({
            namespace: 'BrandLineConfig',
            owner: action.payload.owner,
          })
          .pipe(
            map((res: GetConfigResponse) => {
              return actionBrandLineConfigGetSuccess({
                response: res,
              });
            }),
            catchError(() => of(actionBrandLineConfigGetFailure()))
          );
      }),
    );
  });
}
